import { Routes, Route } from "react-router-dom";
import "assets/css/Plugins.css";
import { useEffect } from "react";
import { AuthProvider } from "routes/AuthContext"; 
import ProtectedRoute from "routes/ProtectedRoute";
import TrackPageViews from "app/utilities/TrackPageViews";
import { ROUTES_BY_ROLE, PUBLIC_ROUTES } from "routes/routesConfig";

const themeApp:any = {
  "--background-100": "#FFFFFF",
  "--background-900": "#070f2e",
  "--shadow-100": "rgba(112, 144, 176, 0.08)",
  "--color-50": "#E9E3FF",
  "--color-100": "#C0B8FE",
  "--color-200": "#A195FD",
  "--color-300": "#8171FC",
  "--color-400": "#7551FF",
  "--color-500": "#422AFB",
  "--color-600": "#3311DB",
  "--color-700": "#2111A5",
  "--color-800": "#190793",
  "--color-900": "#11047A",
};

const App = () => {
  useEffect(() => {
    let color;
    for (color in themeApp) {
      document.documentElement.style.setProperty(color, themeApp[color]);
    }
    
    if (process.env.NODE_ENV === "production") {
      const script = document.createElement("script");
      script.innerHTML = `
      (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6398435,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    document.head.appendChild(script);
    }
  }, []);
    
  return (
    <AuthProvider>
      <TrackPageViews />
      <Routes>
        {PUBLIC_ROUTES.map(({ path, element }) => (
          <Route 
            key={path} 
            path={path} 
            element={<ProtectedRoute allowedRoles={[]}>{element}</ProtectedRoute>} />
        ))}

        {Object.entries(ROUTES_BY_ROLE).map(([role, routes]) =>
          routes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<ProtectedRoute allowedRoles={[role]}>{element}</ProtectedRoute>}
            />
          ))
        )}
      </Routes>
    </AuthProvider>
  );
};

export default App;


